module.exports = __webpack_public_path__ + "static/media/brunchMenu.ed264456.pdf";